import React from "react";
import OfficeAddress from "../components/OfficeAddress";
import ContactForm from "../components/ContactForm";
import "./Contact.css";

const ContactPage = () => {
  return (
    <section id="contact" className="contact-page py-5">
      <div className="container">
        {/* Page Header */}
        <div className="contact-header text-center mb-5">
          <h1 className="contact-title fw-bold">Get In Touch</h1>
          <p className="contact-subtitle">
            Ready to start your project? Contact us and let's create something
            amazing together.
          </p>
        </div>

        <div className="row">
          {/* Office Address */}
          <div className="col-lg-4 mb-4 mb-lg-0">
            <OfficeAddress />
          </div>

          {/* Contact Form */}
          <div className="col-lg-8">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
